import { render, staticRenderFns } from "./ClientsTableWrapper.vue?vue&type=template&id=daf6af10&scoped=true"
import script from "./ClientsTableWrapper.vue?vue&type=script&lang=ts"
export * from "./ClientsTableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ClientsTableWrapper.vue?vue&type=style&index=0&id=daf6af10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf6af10",
  null
  
)

export default component.exports